define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	const AvailableFeatures = require('civicsUtils/available_features');
	const Utils = require('civicsUtils/general_utilities');
	const tpl = require('civicsViews/InviteAuthorizedUsers/templates/t_itv_invite_authorized_users.hbs');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'invitation-item list-row',
		attributes: {
			'role': 'row'
		},
		modelEvents: {
			change: 'render',
		},
		events: {
			'click @ui.removeButton': 'removeInvitationItem',
		},
		ui: {
			removeButton: '.remove-authorized-user-invite',
			applicantTypeSelect: '.applicant-type',
			capacitySelect: '.capacity-type',
			email: '.send-to',
			date: '.effective-start-date',
			time: '.effective-start-time'
		},
		initialize: function (options) {
			this.config = options.config;
			this.invitationsCollection = options.invitationsCollection;
		},
		onShow: function () {

		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		getData: function() {
			var data = Backbone.Syphon.serialize(this);
			data = _.extend(data,Utils.serializeDroppy(this.$el));
			data.authorizedUserEmail = data.authorizedUserEmail.trim();

			var prefixerror = {};
			prefixerror.validationError = {};

			var error = {};
			error.validationError = {};

			//Validate email
			var emailRegex = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
			var email = data.authorizedUserEmail;
			var maxEmailLength = AvailableFeatures.MaxEmailLength();
			data.isValid = true;
			
			if(_.isEmpty(email)){
				error.validationError['authorizedUserEmail'] = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.EMAIL_REQ_ERROR');
				data.isValid = false;
			} else if(!emailRegex.test(email)){
				error.validationError['authorizedUserEmail'] = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.INVALID_EMAIL');
				data.isValid = false;
			} else if(email.length > maxEmailLength){
				error.validationError['authorizedUserEmail'] = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.EMAIL_LENGTH_ERROR', {max:maxEmailLength});
				data.isValid = false;
			} else {
				// Check if the email already exists in the invite collection list
				var emailExists = this.invitationsCollection.some(function(model) {
					return model.get('sentTo') === email;
				});
		
				if (emailExists) {
					error.validationError['authorizedUserEmail'] = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.EMAIL_ALREADY_INVITED');
					data.isValid = false;
				}
			}

			// Activation date and time is not required but if only time is populated it must throw an error that date cannot be empty.
			if (!_.isEmpty(data.effectiveTime) && _.isEmpty(data.effectiveDate)) {
				error.validationError['effectiveDate'] = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.DATE_EMPTY_ERROR');
				data.isValid = false;
			}

			data.effectiveDate = data.effectiveDate;
			data.effectiveTime = data.effectiveTime ? data.effectiveTime : '12:00 AM'; // Set the time with a default value so the effective date isn't null
			data.authorizedUserRole = data.authorizedUserRole ? 'Admin' : 'Non-admin'; // Transform authorizedUserRole boolean to string

			if (!data.isValid) {
				ViewManager.errorToWindow(error, this);
			}
			return data;
		},
		removeInvitationItem: function () {
			this.triggerMethod('invitation-item:remove');
		},
		templateHelpers:function(){
			return {
				config: this.config,
				maxEmailLength: AvailableFeatures.MaxEmailLength()
			}
		},
	});
});
